import {
  RequestMethod,
  RestStandardModuleApiService,
} from '~packages/json-api/client';
import type {
  IEntityBaseApiServiceParams,
  InterceptorRequest,
  InterceptorResponse,
} from '~packages/json-api/client';

import { download } from '@/shared/helpers';

const basePathsSet = new Set<string>();

let fileName: string | null = null;
let formData: FormData | null = null;

const requestInterceptor: InterceptorRequest = ({ method, options, url }) => {
  if (!formData) return options;
  for (const basePath of basePathsSet) {
    if (url.startsWith(basePath)) {
      delete options.headers['Content-Type'];
      options.body = formData;
      return options;
    }
  }

  return options;
};

const responseInterceptor: InterceptorResponse = async ({
  data,
  method,
  response,
}) => {
  if (
    method !== 'download' ||
    !response.headers.get('content-disposition') ||
    !fileName
  )
    return data;
  const blob = await response.blob();
  const ntAddXlsx = fileName.split('.').slice(-1)[0] === 'xlsx';
  await download(blob, fileName, undefined, ntAddXlsx);
};

export default class FileModuleApiService extends RestStandardModuleApiService {
  constructor(params: IEntityBaseApiServiceParams) {
    super(params);
    basePathsSet.add(this.basePath);
  }

  async download(
    data: unknown,
    path = this.pathFetchAll,
    params = {},
    name = 'Новый файл'
  ) {
    fileName = name;
    data instanceof FormData ? (formData = data) : null;
    const response = await super._sendRequest(
      path,
      params,
      data !== null
        ? { body: JSON.stringify(data), method: RequestMethod.POST }
        : { body: null, method: RequestMethod.GET },
      { method: 'download' }
    );
    fileName = null;
    formData = null;
    return response;
  }

  async upload(data: FormData, path = this.pathFetchAll, params = {}) {
    formData = data;
    const response = await super._sendRequest(
      path,
      params,
      { body: JSON.stringify(data), method: RequestMethod.POST },
      { method: 'upload' }
    );
    formData = null;
    return response;
  }
}

FileModuleApiService.register(requestInterceptor);
FileModuleApiService.register(responseInterceptor, true);
